/**
 * Fire-and-forget funnel event → GTM dataLayer + Microsoft Clarity, both
 * loaded by the Shopify theme that embeds this app. All events carry the
 * `pp_` prefix so searching "pp_" surfaces every Print Portal event in GA4,
 * GTM and Clarity alike. GTM forwards `pp_*` custom events to GA4 (trigger
 * regex `pp_.*` → GA4 event tag on G-1C7YPBV8NF — see REWIND_DOCUMENTATION).
 *
 * Outside the theme (local dev, tests) both globals are absent and this is a
 * silent no-op — tracking must never break the ordering flow.
 */
export function track(event: string, params: Record<string, unknown> = {}) {
  const name = `pp_${event}`;
  try {
    (window as unknown as { dataLayer?: unknown[] }).dataLayer?.push({ event: name, ...params });
  } catch {
    /* never break the app for analytics */
  }
  try {
    (window as unknown as { clarity?: (...a: unknown[]) => void }).clarity?.('event', name);
  } catch {
    /* ignore */
  }
}
